import { render, staticRenderFns } from "./VehicleAutoAdvert.vue?vue&type=template&id=55753c8a&"
import script from "./VehicleAutoAdvert.vue?vue&type=script&lang=js&"
export * from "./VehicleAutoAdvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports